export default __webpack_public_path__ + "static/media/armoroffaith.d6f8d8b3.png";